import { useState } from 'react';
import './App.css';
import Navigation from './components/Navigation.tsx';
import Header from './components/Header.tsx';
import CVSummary from './components/CVSummary.tsx';
import ProfessionalSummary from './components/ProfessionalSummary.tsx';
import WorkExperience from './components/WorkExperience.tsx';
import Skills from './components/Skills.tsx';
import AIExperiences from './components/AIExperiences.tsx';
import Certifications from './components/Certifications.tsx';
import AwardsAndLanguages from './components/AwardsAndLanguages.tsx';
import OpenSourceContributions from './components/OpenSourceContributions.tsx';
import ContactButton from './components/ContactButton.tsx';
import BackToTop from './components/BackToTop.tsx';

type SectionType = 'summary' | 'experience' | 'skills' | 'certifications' | 'projects' | 'contact';

function App(): JSX.Element {
  const [activeSection, setActiveSection] = useState<SectionType>('summary');

  const handleSectionChange = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId as SectionType);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation activeSection={activeSection} onSectionChange={handleSectionChange} />
      <div className="py-8">
        <div className="max-w-4xl mx-auto px-4 space-y-8">
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <Header />
          </div>
          
          <section id="summary" className="bg-white rounded-lg shadow-md overflow-hidden">
            <ProfessionalSummary />
          </section>
          
          <section id="cv-summary" className="bg-white rounded-lg shadow-md overflow-hidden">
            <CVSummary />
          </section>

          <section id="experience" className="bg-white rounded-lg shadow-md overflow-hidden">
            <WorkExperience />
          </section>

          <section id="skills" className="bg-white rounded-lg shadow-md overflow-hidden">
            <Skills />
          </section>

          <section id="ai-experiences" className="bg-white rounded-lg shadow-md overflow-hidden">
            <AIExperiences />
          </section>

          <section id="certifications" className="bg-white rounded-lg shadow-md overflow-hidden">
            <Certifications />
          </section>

          <section id="awards-languages" className="bg-white rounded-lg shadow-md overflow-hidden">
            <AwardsAndLanguages />
          </section>

          <section id="projects" className="bg-white rounded-lg shadow-md overflow-hidden">
            <OpenSourceContributions />
          </section>

          <section id="contact" className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Contact Information</h2>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <span className="text-blue-600">📧</span>
                  <span>qtvhao@gmail.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-blue-600">📍</span>
                  <span>Hanoi, Vietnam</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-blue-600">📱</span>
                  <span>(+84) 902132497</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-blue-600">💼</span>
                  <a href="http://linkedin.com/in/haon-x" className="text-blue-600 hover:underline">LinkedIn Profile</a>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-blue-600">🐙</span>
                  <a href="http://github.com/qtvhao" className="text-blue-600 hover:underline">GitHub Profile</a>
                </div>
              </div>
              <ContactButton />
            </div>
          </section>
        </div>
      </div>
      
      <footer className="bg-white text-gray-800 py-6 mt-12 border-t">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Nghiem Xuan Hao. All rights reserved.
          </p>
        </div>
      </footer>
      <BackToTop />
    </div>
  );
}

export default App;
